/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.PostPurchaseTrackingSignup = class PostPurchaseTrackingSignup {
  constructor(el, controller) {
    this._redirectToClaimSubmission = this._redirectToClaimSubmission.bind(this);
    this._setup = this._setup.bind(this);
    this.el = el;
    this.controller = controller;
    setTimeout(this._setup, 0);
  }

  _redirectToClaimSubmission(voucherResult) {
    const submissionUrl = voucherResult.newly_registered ?
      this.el.data("new-friend-submission-url")
    :
      this.el.data("returning-friend-submission-url");
    return window.open((submissionUrl), "_self");
  }
  _setup() {
    const friendLandingPage = this.el.find("form").data("FriendLandingPage");
    return friendLandingPage.onSuccess(this._redirectToClaimSubmission);
  }
};
